import { getResource } from '../utilities/service-utils'

export const getAllCountries = () => {
  return getResource('country')
}
